import { render, staticRenderFns } from "./TherapyManagementBlock.vue?vue&type=template&id=2d5e0de3&scoped=true"
import script from "./TherapyManagementBlock.vue?vue&type=script&lang=js"
export * from "./TherapyManagementBlock.vue?vue&type=script&lang=js"
import style0 from "./TherapyManagementBlock.vue?vue&type=style&index=0&id=2d5e0de3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e0de3",
  null
  
)

export default component.exports